import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Functional HTTP interceptor that attaches the JWT access token
 * to all outgoing API requests as a Bearer token.
 *
 * Reads the token from localStorage (set by AuthService on login/register).
 * Skips adding the header if no token is present (e.g. login/register requests).
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem('accessToken');

  if (token) {
    const authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
    return next(authReq);
  }

  return next(req);
};

